module.exports = __webpack_public_path__ + "public/upArrow.svg?09b4c30f";